import vuex from "vuex";
import localStorage from "../../helper/localStorage";
import http from "../../helper/http";

/**
 * 用户登录数据以及状态管理store
 */

const state = {
    userInfo: undefined,
    loginStatus: false
}

const getters = {
    userInfo: async () => {
        if (state.state == undefined) {
            await mutations.changeUserInfoAsync();
        }
        return state.userInfo;
    }
}

const actions = {
    async changeUserInfo({ commit }) {
        return await commit('changeUserInfoAsync', null);
    }
}

const mutations = {
    async changeUserInfoAsync() {
        let userInfo = await http.get("/user/getloginuserinfo");
        state.userInfo = userInfo;
        return true;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js